import React from 'react';
import { useStyletron } from 'baseui';
import { ButtonRow } from '@gtintel/platform-atoms';
import { COMPLETE_ID, MATCHED_ID, PENDING_ID, PROJECT_ACTIVATED_ID, SCOPING_ID } from '@gtintel/platform-constants';
import { ActivateProjectButton, CloseProjectButton, CompleteProjectButton } from '../../../components/Buttons';
import { ProjectContext } from '../../context';
const ActionButtons = () => {
  const {
    status,
    reports
  } = React.useContext(ProjectContext);
  const [css] = useStyletron();
  return <section className={css({
    margin: '18px 0'
  })}>
      {status() === PENDING_ID && <ButtonRow>
          <CloseProjectButton />
        </ButtonRow>}

      {status() === MATCHED_ID && <ButtonRow>
          <ActivateProjectButton />
          <CloseProjectButton />
        </ButtonRow>}

      {status() === SCOPING_ID && <div className={css({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    })}>
          <ButtonRow>
            <ActivateProjectButton />
            <CloseProjectButton />
          </ButtonRow>
        </div>}

      {status() === PROJECT_ACTIVATED_ID && reports() && <CompleteProjectButton />}

      {status() === COMPLETE_ID && <ButtonRow>
          <CloseProjectButton />
        </ButtonRow>}
    </section>;
};
export default ActionButtons;